'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessageKey = undefined;

var _PubNubMessageKey = require('../../records/PubNubMessageKey');

var _PubNubMessageKey2 = _interopRequireDefault(_PubNubMessageKey);

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _pubnubMessageGetters = require('./pubnubMessageGetters');

var _isCommentMessage = require('./isCommentMessage');

var _isCommonMessageFormat = require('../../common-message-format/operators/isCommonMessageFormat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildMessageKey = exports.buildMessageKey = function buildMessageKey(message) {
  if ((0, _isCommentMessage.isCommentMessage)(message) || (0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return (0, _pubnubMessageGetters.getId)(message);
  }

  return (0, _PubNubMessageKey2.default)({
    clientTs: (0, _commonMessageFormatGetters.getClientTs)(message),
    senderId: (0, _commonMessageFormatGetters.getSenderId)(message),
    senderType: (0, _commonMessageFormatGetters.getSenderType)(message)
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/buildMessageKey.js
// module id = 113
// module chunks = 2 3